import React, { useContext } from "react";
import { EventContext } from "../context/EventContext";
import { CartContext } from "../context/CartContext";
import { CLOSE_CART } from "../reducers/CartReducer";
import { Link } from "react-router-dom";
import {
  getBitmap,
  getPriceString,
  getEncodedProductStyle,
  getEncodedProductColor,
} from "../helpers";

const CartProduct = ({ productID, size, addLogo }) => {
  const { eventID, products, customUnits, discountPercentage, logoFee } =
    useContext(EventContext);
  const { cartDispatch } = useContext(CartContext);
  const product = products[productID];
  const productStyle = getEncodedProductStyle(product);
  const productColor = getEncodedProductColor(product);
  const productPath = product
    ? `/${eventID}/store/product/${productStyle}/${productColor}`
    : `/${eventID}`;

  if (!product) return null;

  // Calculate the product price with the logo surcharge (per-event, from Firestore).
  // Coerce product.price to Number because Firestore stores it as a string in some
  // catalogs (e.g. CPG), which would otherwise turn `price + 5` into string concat.
  const surcharge = addLogo ? Number(logoFee) || 0 : 0;
  const calculatePrice = Number(product.price) + surcharge;

  const lastPrice =
    calculatePrice - calculatePrice * (parseFloat(discountPercentage) / 100);

  return (
    <div className="cartProduct">
      <Link
        onClick={() => cartDispatch({ type: CLOSE_CART })}
        to={productPath}
        className="storefrontProduct"
      >
        <img
          alt="product"
          src={getBitmap(product.image)}
          className="productImage skeleton"
        />
      </Link>
      <div className="productDetails">
        <span className="productName">{product.styleNameLong}</span>
        <span className="productSize">Size: {size}</span>
        <span className="productPrice">
          {discountPercentage && discountPercentage > 0 ? (
            <div style={{ display: "flex", gap: "10px" }}>
              <span
                className="productPrice"
                style={{ textDecoration: "line-through" }}
              >
                {getPriceString(calculatePrice, customUnits)}
              </span>
              <span className="productPrice">
                {getPriceString(lastPrice, customUnits)}
              </span>
            </div>
          ) : (
            <span className="productPrice">
              {getPriceString(calculatePrice, customUnits)}
            </span>
          )}
        </span>
      </div>
    </div>
  );
};

export default CartProduct;
